<template>
  <div
    class="flex w-full items-center gap-4.5 border bg-[#F9F9F9] p-4 transition-all md:p-5"
    :class="{
      'cursor-pointer hover:border-gray-90': !disabled,
      'opacity-50': disabled,
      'border-gray-90': isActive,
      'border-gray-10': !isActive,
    }"
    @click="handleClick"
  >
    <!-- Radio Button -->
    <div class="h-5 shrink-0">
      <input
        :id="internalId"
        v-model="internalValue"
        type="radio"
        :name="name"
        :value="value"
        :disabled="disabled"
        class="size-5 cursor-pointer rounded-full border border-primary"
        :class="isActive ? 'text-primary' : 'text-white'"
      />
    </div>

    <!-- Content -->
    <div class="flex-1">
      <div class="text-sm">
        <span class="font-bold">
          {{ title }}
        </span>
        <span v-if="price" class="font-normal">
          - {{ $n(price, "currency") }}*
        </span>
      </div>
      <div
        v-if="description"
        class="mt-1 text-sm font-normal"
        v-html="description"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: string | number | null;
  name: string;
  value: string | number;
  title: string;
  description?: string;
  price?: string | number | null;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  description: "",
  price: "",
  disabled: false,
});

const emit = defineEmits<{
  "update:modelValue": [value: string | number];
}>();

const internalId = useId();

const internalValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (newValue !== null) {
      emit("update:modelValue", newValue);
    }
  },
});

const handleClick = () => {
  if (!props.disabled) {
    internalValue.value = props.value;
  }
};

// Check if this option is currently selected
const isActive = computed(() => {
  return props.modelValue === props.value;
});
</script>
